import { every } from 'lodash';

import cookie from 'js/lib/cookie';

import type { ModificationProps } from 'bundles/ent-website/contentful/modules/MarketoModule';

const populateMarketoHiddenFields = ({ mktoFormId, router, domain }: ModificationProps) => {
  const mkto = window.MktoForms2;
  const mktoForm = mkto?.getForm(mktoFormId);

  const cookieId = cookie.get('__204u') ?? '';
  const utmCampaign = router.location.query?.utm_campaign ?? '';
  const utmContent = router.location.query?.utm_content ?? '';
  const utmMedium = router.location.query?.utm_medium ?? '';
  const utmSource = router.location.query?.utm_source ?? '';
  const utmTerm = router.location.query?.utm_term ?? '';
  const data = {
    Session_Cookie_ID__c: cookieId,
    utm_campaign__c: utmCampaign,
    utm_content__c: utmContent,
    utm_medium__c: utmMedium,
    utm_source__c: utmSource,
    utm_term__c: utmTerm,
    referrerDomainonSubmit: domain,
  };

  const formValues = mktoForm?.getValues();
  const allFilled = every(Object.values(formValues ?? []), (val) => !!val);
  // "Known user" forms have 2 fields that are already filled
  // Regular forms have "" values for the majority of fields
  if (formValues && allFilled) {
    mktoForm?.addHiddenFields(data);
  } else {
    mktoForm?.setValues(data);
  }
};

export { populateMarketoHiddenFields };
